import React from 'react';

class WizardLoading extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      loading: props.wizardLoadingText,
    };
  }

  componentDidUpdate(prevProps) {
    const { wizardLoadingText } = this.props;
    const { loading, loadingBuffer } = this.state;

    if (wizardLoadingText !== prevProps.wizardLoadingText && loading && !loadingBuffer) {
      this.setState({
        loadingBuffer: true,
      });
      setTimeout(() => {
        this.setState({
          loading: false,
          loadingBuffer: false,
        });
      }, 1000);
    } else if (prevProps.wizardLoadingText != wizardLoadingText) {
      this.setState({
        loading: wizardLoadingText,
      });
    }
  }

  render() {
    const { wizardLoadingText } = this.props;
    const { loading, loadingBuffer } = this.state;

    return (
      <>
        {loading && (
          <div className={'bg-[rgba(40,39,126,0.8)] w-full h-full fixed top-0 left-0 z-10 center'}>
            <div className=" flex h-screen">
              <div className="m-auto text-white">
                <i
                  className={`fad wizard-loader ${loadingBuffer ? 'fa-check-circle' : 'fa-spinner ev-spin'} text-6xl`}
                />
                <div className={`pt-4 font-bold ${loadingBuffer ? '' : 'loading-text'}`}>
                  {loadingBuffer ? 'Done!' : wizardLoadingText}
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default WizardLoading;
